module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("— Jonah, si tu ne veux pas en parler parce que tu travaillais dans le secteur de la technologie, je comprends. Mais ce ne serait vraiment pas…")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Ça n’a rien à voir avec ça, répondit Jonah, sa voix vibrant de frustration. Je…")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Il se releva et se dirigea vers le bord de l’eau.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Merde.")]), _vm._v(" Adam se sentait mal. Il avait évoqué quelque chose dont Jonah n’avait clairement pas envie de parler. Même s’il voulait en savoir plus sur Jonah, sa dernière envie était de gâcher leur journée. Il se leva et posa une main hésitante sur l’épaule de l’autre homme. Il s’attendait presque à ce que Jonah s’emporte contre lui, mais au contraire, tout son corps se détendit sous sa main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Je suis désolé, dit Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Toi ? Non, c’est ma faute. J’aurais dû comprendre que tu ne voulais pas m’en parler.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Jonah poussa un long soupir et secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Ce n’est pas ce que tu crois.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Je ne comprends pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Ce n’est pas que je ne veux pas parler de moi-même, dit Jonah, la voix calme, même si Adam sentait une source de tension sous-jacente. C’est juste que je ne me souviens pas. Je ne me souviens de rien.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc0bf46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 63
// module chunks = 0